import { render, staticRenderFns } from "./Efp.vue?vue&type=template&id=44b8b87d&scoped=true&"
import script from "./Efp.vue?vue&type=script&lang=js&"
export * from "./Efp.vue?vue&type=script&lang=js&"
import style0 from "./Efp.vue?vue&type=style&index=0&id=44b8b87d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b8b87d",
  null
  
)

export default component.exports